import React, { Component } from 'react';
import { Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import { RequireClaims } from './components/auth/RequireClaims';

import Worksheet from './components/worksheet/Worksheet'
import PrintWorksheet from './components/print/Worksheet'
import SearchForm from './components/search/SearchForm'
import InsuranceMappings from './components/admin/InsuranceMappings'
import Troubleshooting from './components/admin/Troubleshooting'
import NotFound from './components/NotFound'
import Unauthorized from './components/Unauthorized'
import { AuthProvider } from './components/auth/UseAuth'

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <AuthProvider>
                <Layout>
                    <Routes>
                        <Route index element={<RequireClaims><Worksheet /></RequireClaims>} />
                        <Route path='/Worksheet/:estimateId' element={<RequireClaims><Worksheet /></RequireClaims>} />
                        <Route path='/Worksheet/Patient/:patientId' element={<RequireClaims><Worksheet /></RequireClaims>} />
                        <Route path='/Print/:estimateId' element={<RequireClaims><PrintWorksheet /></RequireClaims>} />
                        <Route path='/Search' element={<RequireClaims><SearchForm /></RequireClaims>} />
                        <Route path='/Admin/InsuranceMappings' element={<RequireClaims role={['Admin']}><InsuranceMappings /></RequireClaims>} />
                        <Route path='/Admin/Troubleshooting' element={<RequireClaims role={['Admin']}><Troubleshooting /></RequireClaims>} />
                        <Route path='/Unauthorized' element={<Unauthorized />} />
                        <Route path='*' element={<NotFound />} />
                    </Routes>
                </Layout>
            </AuthProvider>
        );
    }
}
